module.exports = __webpack_public_path__ + "assets/envoy.788f77df.svg";